import { QueryObserverResult, useQuery } from "@tanstack/react-query";
import { ProcurementSupplierHubDto } from "@green0meter/api-client";

import { DOMAIN_PROCUREMENT } from "../domain";

import { procurementApi } from "@api/services";
import { TANSTACK_QUERY_STALE_TIME } from "@constants";

export const ACTION_GET_PROCUREMENT_SUPPLIER_HUBS = "GET_PROCUREMENT_SUPPLIER_HUBS";

const getProcurementSupplierHubs = async (): Promise<
  ProcurementSupplierHubDto[]
> => {
  const response =
    await procurementApi.procurementControllerGetProcurementSupplierHubs();

  return response.data;
};

export const useGetProcurementSupplierHubs = (): {
  hubs: ProcurementSupplierHubDto[] | undefined;
  isPendingProcurementSupplierHubs: boolean;
  isSuccessGetProcurementSupplierHubs: boolean;
  refetchHubs: () => Promise<
    QueryObserverResult<ProcurementSupplierHubDto[], Error>
  >;
} => {
  const { data, isPending, isSuccess, refetch } = useQuery({
    queryKey: [DOMAIN_PROCUREMENT, ACTION_GET_PROCUREMENT_SUPPLIER_HUBS],
    queryFn: () => getProcurementSupplierHubs(),
    select: (response) => response,
    staleTime: TANSTACK_QUERY_STALE_TIME,
    enabled: !!localStorage.getItem("access_token"),
  });

  return {
    hubs: data,
    isPendingProcurementSupplierHubs: isPending,
    isSuccessGetProcurementSupplierHubs: isSuccess,
    refetchHubs: refetch,
  };
};
